import { useCallback } from "react"

import { SelectOption } from "shared/types/Select"

/**
 * Returns a callback function that checks if a given option is disabled based on the provided disabledOptions array.
 * @template T - The type of the option value.
 * @param disabledOptions - Optional. An array of disabled options.
 * @returns A callback function that takes an option and returns a boolean indicating if the option is disabled.
 */
export function useIsOptionDisabled<T>(disabledOptions?: T[] | null) {
  return useCallback(
    (option: SelectOption<T>) =>
      !!disabledOptions?.includes(option.value) || !!option.disabled,
    [disabledOptions]
  )
}
